import {endpoints} from './endpoints'
import request from '../../request'

export function getDocumentsListing(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDocumentsListing,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setDocumentInfo(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setDocumentInfo,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}